export const CanvasLevelType = {
    FRONT:'Front',
    BACK:'Back',
};
